module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/pricing_plan_select/meal_kit-0a7380bf784ec5f01b335fb4fca46dec.jpg";